
import { createRouter, createWebHashHistory} from 'vue-router'
import transitionExtend from "./routerExtendHistory";
import { constantRouterMap } from './router.config.js'
import store from '@/store';

//路由注入
let router = new createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHashHistory(),

    routes: constantRouterMap, // `routes: routes` 的缩写
    scrollBehavior: (to, from, position) => {
        if (position) {
            return position
        } else {
            return { x: 0, y: 0 }
        }
    },
})

// 对router对象扩展
router = transitionExtend(router)

// export 扩展后的路由对象
export default router
